import React, { Component } from 'react';
import H3Subtitle from '../H3Subtitle/H3Subtitle.js';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import Spinner from '../Spinner/Spinner.js'
import FeedbackItem from '../FeedbackItem/FeedbackItem.js';
import { $qs, $qsa, controlElementBasedOnScrollVisibility, elementLoadCheck } from "../../helpers/misc-javascript-helpers.js";


class FeedbackItemsCarousel extends Component {
    constructor(props) {
        super(props);
        this.carouselTestimonialsRef = React.createRef();
        this.state = {
            isLoading: true,
            blockTitle: '',
            feedbackData: {},
            selectedIndex: 0,
            carouselPaused: true,
            disabledCounter: 1
        }
        this.htmlSrcElement = '';
        this.getTestimonials = this.getTestimonialsCall.bind(this);
        /* FIX-ME - Disabling - causes screen to jitter */
        // this.handlePauseCarousel = this._handlePauseCarousel.bind(this);
    }

    componentDidMount() {
        this.getTestimonials();
        /* Check to see if the carousel element is available for querying, and if so assign */
        if (elementLoadCheck('#feedbackItemsCarousel')) {
            this.carouselContainer = $qs('#feedbackItemsCarousel');
        }
        /* Check to see if the body/html elements are available for 
        querying in addition to the carousel container, and if so assign html/body 
        per the user agent results */
        if (elementLoadCheck('html,body') && this.carouselContainer) {
            this.htmlSrcElement = $qs('html,body');
            if (window.navigator.userAgent.match(/Edge/)) {
                // IE Edge target for scrollTop
                this.htmlSrcElement = document.body;
            }
        }
        /* Assign events for scroll support onload and onscroll */
        /* FIX-ME - Disabling - causes screen to jitter */
        // window.addEventListener('load', this.handlePauseCarousel);
        // window.addEventListener('scroll', this.handlePauseCarousel);

    }

    /**
     * @method getTestimonialsCall - Retrieve testimonials data from the course api via the provided prop.
     */
    async getTestimonialsCall() {
        let allTestimonials = { data: [] };
        let returnedData;
        try {
            if (typeof this.props.data === 'function') { // check the props type for 'function' to make api call
                allTestimonials = await this.props.data(1, 10);
                returnedData = allTestimonials.data.data ? allTestimonials.data.data : {};
            } else { // otherwise take the data directly - as is.
                allTestimonials.data = this.props.data ? this.props.data : {};
                returnedData = allTestimonials ? allTestimonials : {};
            }
            this.setState({ feedbackData: returnedData });
            this.setState({ blockTitle: this.props.blockTitle });
            this.setState({ isLoading: false });

        } catch (error) {
            console.error(error);
        } finally {
            this._detailControlButtons();
        }
    }

    /** Turns off the carousel when it is outside of a safe area (offscreen) */
    _handlePauseCarousel(pageContentParam) {
        /* Since the carousel is designed to reset when a state change occurs, store the 
        current selectedItem or slide.*/
        let currentSlide = this.carouselTestimonialsRef.current.state.selectedItem;
        const clientElement = this.htmlSrcElement;
        const pageContentOffsetTop = $qs('#pageContent').offsetTop ? $qs('#pageContent').offsetTop : pageContentParam;
        let carouselScrollStatusMessage = false;
        carouselScrollStatusMessage = controlElementBasedOnScrollVisibility(this.state.disabledCounter, this.state.carouselPaused,
            this.carouselContainer, this.htmlSrcElement, clientElement, pageContentOffsetTop, null, null);

        /* Set relevant states to be used in controlling props or as variable references on qualified update */
        if (carouselScrollStatusMessage.hasJustUpdated) {
            this.setState({ carouselPaused: carouselScrollStatusMessage.status });
            this.setState({ disabledCounter: carouselScrollStatusMessage.disInteger });
            /* Use carouselScrollStatusMessage to set the length to 0 if carousel is to be paused, otherwise set to length of bannerData state */
            this.carouselTestimonialsRef.current.setState({ autoPlay: (this.state.carouselPaused) ? false : true });
            /* Stop built-in carousel reset and use currentSlide value */
            this.carouselTestimonialsRef.current.setState({ selectedItem: currentSlide });
        }
        return { currentSlide: currentSlide, updateMessage: carouselScrollStatusMessage };
    }

    /**
    * @method - detailControlButtons - adds accessibility requirements to the control buttons
    */
    _detailControlButtons = () => {
        let learnerFeedbackCarousel;
        if ($qs('#feedbackItemsCarousel')) {
            learnerFeedbackCarousel = $qs('#feedbackItemsCarousel');
            /* Access button controls */
            const controlArrow = learnerFeedbackCarousel.querySelectorAll('.control-arrow');
            const controlDots = learnerFeedbackCarousel.querySelectorAll('.control-dots .dot');
            /* Run loop to add accessibility details to buttons */
            controlArrow.forEach(element => {
                var buttonLabel = (element.classList.contains('control-prev')) ? "Previous Slide" : "Next Slide";
                element.setAttribute('aria-hidden', 'false');
                element.setAttribute('aria-label', buttonLabel);
                element.setAttribute('tabindex', '0');
                element.innerHTML = buttonLabel;
            });
            setTimeout(() => {
                if (typeof (controlDots) !== undefined && controlDots.length > 0) {
                    controlDots.forEach(element => {
                        element.setAttribute('role', 'button');
                    });
                }
            }, 500);
        }
    }

    render() {
        return (
            <React.Fragment>
                <Spinner isLoading={this.state.isLoading}></Spinner>
                <div className="container feedback__carousel__block">
                    <H3Subtitle
                        titleClass={this.props.blockTitleClass}
                        titleText={this.state.blockTitle}
                    ></H3Subtitle>
                    <Carousel
                        showArrows={true}
                        showStatus={false}
                        autoPlay={(this.state.carouselPaused) ? false : true}
                        showIndicators={true}
                        showThumbs={false}
                        infiniteLoop={true}
                        interval={5000}
                        transitionTime={600}
                        dynamicHeight={true}
                        emulateTouch={true}
                        ref={this.carouselTestimonialsRef}
                    >
                        {(typeof (this.state.feedbackData.data) !== 'undefined') ? this.state.feedbackData.data.map((feedback, index) =>
                            <FeedbackItem key={index}
                                first_name={feedback.testimonial.first_name}
                                last_name={feedback.testimonial.last_name}
                                testimonial={feedback.testimonial.testimonial}
                                title={feedback.testimonial.title}
                                course_id={feedback.testimonial.course_id}
                                course_title={feedback.testimonial.course_title}
                                course_slug={feedback.testimonial.course_slug}
                                certificate={feedback.testimonial.parent_suite_name}
                                certificate_id={feedback.testimonial.parent_suite_id = false} // purposely set to false to hide certification information
                                certificate_slug={feedback.testimonial.parent_suite_slug}
                                multiplier={index}
                                disableLinks={false}
                            >
                            </FeedbackItem>
                        ) : ''}
                    </Carousel>
                </div>
            </React.Fragment>
        );
    }
}

export default FeedbackItemsCarousel;